export var MODAL_ENTER_DURATION = 250;
export var MODAL_EXIT_DURATION = 150;